// Function to handle adding/removing favorites in local storage
export const handleFavorite = (_id) => {
  const authUser = JSON.parse(localStorage.getItem('authUser'));
  const key = authUser?.email ? `favorites_${authUser.email}` : 'favorites';
  const favorites = JSON.parse(localStorage.getItem(key)) || [];
  const isFavorite = favorites.includes(_id);

  if (isFavorite) {
    const updatedFavorites = favorites.filter((id) => id !== _id);
    localStorage.setItem(key, JSON.stringify(updatedFavorites));
  } else {
    favorites.push(_id);
    localStorage.setItem(key, JSON.stringify(favorites));
  }
};

// Function to retrieve favorites from local storage
export const getFavorites = () => {
  const authUser = JSON.parse(localStorage.getItem('authUser'));
  const key = authUser?.email ? `favorites_${authUser.email}` : 'favorites';
  return JSON.parse(localStorage.getItem(key)) || [];
};